<div>
    <div class="checklist">
      <div class="checklist-name">
        <span>{{item.displayName}}</span>
        <span *ngIf="item.status" title="{{ 'checklist.checklistItemIsOnline' | translate }}" class="status"></span>
        <span  class="warning-icon">
          <span class="material-icons" *ngIf="!item.status && !item.duration"  [matTooltip]="'checklist.pleaseAddDuration' | translate"
  matTooltipClass="asp-custom-tooltip">info</span>
        </span>
      </div>
    </div>
</div>